import React, { createContext, useContext, useEffect, useState } from 'react';

const DEFAULT_CONFIG = {
  showWetlandPins: true,
  showAddWetlandFab: true,
};

const ConfigContext = createContext(DEFAULT_CONFIG);

export const useConfig = () => useContext(ConfigContext);

export const ConfigProvider = ({ children }) => {
  const [config, setConfig] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const resp = await fetch(`/config.json?t=${Date.now()}`, {
          headers: { Accept: 'application/json' },
        });
        if (!resp.ok) throw new Error(`config.json HTTP ${resp.status}`);
        const json = await resp.json();
        if (!cancelled) setConfig({ ...DEFAULT_CONFIG, ...json });
      } catch (err) {
        console.warn('Falling back to default config:', err);
        if (!cancelled) setConfig(DEFAULT_CONFIG);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  if (!config) return null;

  return (
    <ConfigContext.Provider value={config}>
      {children}
    </ConfigContext.Provider>
  );
};
